export const host = "https://tele-chat-api.herokuapp.com";
// export const host = "http://localhost:9090";
export const loginRoute = `${host}/api/auth/login`;
export const registerRoute = `${host}/api/auth/register`;
export const logoutRoute = `${host}/api/auth/logout`;
export const allUsersRoute = `${host}/api/auth/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const recieveMessageRoute = `${host}/api/messages/getmsg`;
export const setAvatarRoute = `${host}/api/auth/setavatar`;
export const forgetPasswordRoute = `${host}/api/auth/forgetpassword`;
export const resetPasswordRoute = `${host}/api/auth/resetpassword`;
export const signUpWithGoogle = `${host}/api/auth/googleSignUp`;
export const loginWithGoogle = `${host}/api/auth/googleLogIn`;
